import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./Desalter2.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";

import { trackPageVisit } from "../competency/PageTracker";
import Analyzer1Faceplate from "../components/Analyzer1Faceplate";
import AnalyzerV201AFaceplate from "../components/AnalyzerV201AFaceplate";
import AnalyzerV201BFaceplate from "../components/AnalyzerV201BFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import ElectricGrid from "../components/ElectricGrid";
import ElectricGridButton from "../components/ElectricGridButton";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function Desalter2() {

    useEffect(() => {
    
      trackPageVisit("Desalter2");
    
    }, []);
  
     const { toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const [showMDS, setShowMDS] = useState(false);
const [showAnalyzerV201A, setShowAnalyzerV201A] =  useState(false);
const [showAnalyzerV201B, setShowAnalyzerV201B] =  useState(false);

     

  const DEFAULT_VALVES = {
  PDV_13001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  LCV_13001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13002: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13003: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13004: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13005: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13006: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Desalter2_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      PDV_13001: { ...DEFAULT_VALVES.PDV_13001, ...parsed.PDV_13001 },
      LCV_13001: { ...DEFAULT_VALVES.LCV_13001, ...parsed.LCV_13001 },
      FCV_13001: { ...DEFAULT_VALVES.FCV_13001, ...parsed.FCV_13001 },
      FCV_13002: { ...DEFAULT_VALVES.FCV_13002, ...parsed.FCV_13002 },
      FCV_13003: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_13003 },
      FCV_13004: { ...DEFAULT_VALVES.FCV_13004, ...parsed.FCV_13004 },
      FCV_13005: { ...DEFAULT_VALVES.FCV_13005, ...parsed.FCV_13005 },
      FCV_13006: { ...DEFAULT_VALVES.FCV_13006, ...parsed.FCV_13006 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Desalter2_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };





  // =============================
  // ELECTRIC GRID STATE
  // =============================
  const [gridState, setGridState] = useState("STOP");
  const [ZI_13001, setZI_13001] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      if (gridState === "START") {
        setZI_13001(prev => {
          if (prev >= 55)
            return 55;
          return Number(
            (prev + 0.3).toFixed(2)
          );
        });
      }
      if (gridState === "STOP") {
        setZI_13001(0);
      }
    }, 500);
    return () => clearInterval(timer);
  }, [gridState]);





// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

             const { transmitters, } = usePlantStore();
            const TT_12001 = transmitters.TT_12001 || 0;
            const FIC_12006 = transmitters.FIC_12006 || 0;
            const FIC_12011 = transmitters.FIC_12011 || 0;
            const FIC_11012 = transmitters.FIC_11012 || 0;
            const FIC_3904 = transmitters.FIC_3904 || 0;



  const xv13001Open = !valves?.XV_13001;
  const xv13002Open = !valves?.XV_13002;
  const xv13003Open = !valves?.XV_13003;
  const xv13004Open = !valves?.XV_13004;
  const psv13001Open = !valves?.PSV_13001;



  const FIC_13001 = FIC_12011;
  const TT_13001 = FIC_13001 > 1 ?  TT_12001+(TT_12001*0.05) : 27;

  const FIC_13002 = 30.354 * (valveData?.FCV_13002?.opening || 0)/100;  // ================= DECALSIFIER
  const FIC_13003 = 60.354 * (valveData?.FCV_13003?.opening || 0)/100;  // ================= DEMULSIFIER
  const FIC_13004 = FIC_3904 * (valveData?.FCV_13001?.opening || 0)/100;   // ================= WASH WATER
  const FIC_13005 = 0.645 * (valveData?.FCV_13004?.opening || 0)/100;   // ================= RINSE WATER
  const FIC_13007 = 4.545 * (valveData?.LCV_13001?.opening || 0)/100;   // ================= BRIME WATER DRAINAGE

  const FIC_13008 = ((FIC_13001) + (FIC_13002/1000/159) + (FIC_13003/1000/159) + (FIC_13004)) * (valveData?.PDV_13001?.opening || 0)/70;
  const FIC_13009 = xv13001Open && (xv13002Open || xv13003Open) ? 40.545 * (valveData?.FCV_13006?.opening || 0)/100 : 0;
  const FIC_13010 = xv13004Open ? 25.43 : 0;
  
  
   /* =========================================================
              SPLITTING OF MAIN BLENDING LINE
========================================================= */

const openV201ALine =
[
  xv13002Open,
  xv13003Open
].filter(Boolean).length;

const FIC_13012 =
  xv13002Open
    ? FIC_13009 / openV201ALine
    : 0;

const FIC_13011 =
  xv13003Open
    ? FIC_13009 / openV201ALine
    : 0;


  const FIC_13013 = (((FIC_13002/1000/159) + (FIC_13003/1000/159) + (FIC_13004)) * (valveData?.PDV_13001?.opening || 0)/100) + FIC_13005;  // ================= WATER AND CHECMICAL INJECTION RATE


const MixValveOpening2 = (valveData?.PDV_13001?.opening || 0)/100;
    
const FIC_12013 = FIC_12006;



/* =========================================================
   P-250A / P-250B PUMP LOGIC
========================================================= */


/* =========================================================
   PUMP CONTEXT
========================================================= */
const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});

/* =========================================================
   PUMP STATES
========================================================= */

/* =========================================================
   REAL PUMP RUNNING STATUS FROM PUMPCONTEXT
========================================================= */

const P250A_Running =
  pumpData?.["P-250A"]?.running || false;

const P250B_Running =
  pumpData?.["P-250B"]?.running || false;

/* =========================================================
   PUMP RUN STATUS
========================================================= */

const anyPumpRunning =
  P250A_Running ||
  P250B_Running;

/* =========================================================
   VALVE OPENING
========================================================= */

const valveOpening =
  (valveData?.FCV_13005?.opening || 0) / 100;

/* =========================================================
   FLOWRATE CALCULATION
========================================================= */

const maxPumpRate = 45.465;

/* =========================================================
   DISCHARGE FLOW
========================================================= */

const FIC_13006 =
  anyPumpRunning
    ? (
        maxPumpRate *
        valveOpening
      ).toFixed(2)
    : 0;

/* =========================================================
   SECOND FLOW TAG
========================================================= */

const FIC_13006a =
  anyPumpRunning
    ? (
        maxPumpRate
        ).toFixed(2)
    : 0;

/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_13002 =
  anyPumpRunning
    ? (
        1.3 *
        valveOpening
      ).toFixed(2)
    : 0;

/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_13002 =
  anyPumpRunning
    ? (
        55 *
        valveOpening
      ).toFixed(1)
    : 0;

/* =========================================================
   SAVE TO LOCAL STORAGE
========================================================= */

useEffect(() => {

  localStorage.setItem(
    "FIC_13006",
    FIC_13006
  );

  localStorage.setItem(
    "FIC_13006a",
    FIC_13006a
  );

  localStorage.setItem(
    "PT_13002",
    PT_13002
  );

  localStorage.setItem(
    "TT_13002",
    TT_13002
  );

}, [

  FIC_13006,
  FIC_13006a,
  PT_13002,
  TT_13002

]);

/* =========================================================
   PUMP AUTO CHANGEOVER
========================================================= */

useEffect(() => {

  if(
    !P250A_Running &&
    !P250B_Running
  ){

    localStorage.setItem(
      "Pump250_Status",
      "STOPPED"
    );

  }
  else if(
    P250A_Running &&
    !P250B_Running
  ){

    localStorage.setItem(
      "Pump250_Status",
      "P250A RUNNING"
    );

  }
  else if(
    !P250A_Running &&
    P250B_Running
  ){

    localStorage.setItem(
      "Pump250_Status",
      "P250B RUNNING"
    );

  }
  else{

    localStorage.setItem(
      "Pump250_Status",
      "DUAL OPERATION"
    );

  }

}, [

  P250A_Running,
  P250B_Running

]);



const FIC_13006c = FIC_13006 * 0.967;



    



useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_13006 === FIC_13006 &&
    current.TT_13001 === TT_13001 &&
    current.FIC_13006a === FIC_13006a &&
    current.MixValveOpening2 === MixValveOpening2 &&
    current.TT_13001 === TT_13001 &&
    current.ZI_13001 === ZI_13001 &&
    current.FIC_13005 === FIC_13005 &&
    current.FIC_13004 === FIC_13004 &&
    current.FIC_13003 === FIC_13003 &&
    current.FIC_13002 === FIC_13002 &&
    current.FIC_13007 === FIC_13007 &&
    current.FIC_13006 === FIC_13006 &&
    current.FIC_13012 === FIC_13012 &&
    current.FIC_13011 === FIC_13011 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_13006, TT_13001, FIC_13007, FIC_13012, FIC_13006, FIC_13006a, MixValveOpening2, TT_13001, ZI_13001, FIC_13005, FIC_13004, FIC_13003, FIC_13002, FIC_13011, 
    }
  });

}, [FIC_13006, FIC_13007, FIC_13012, FIC_13006, TT_13001, FIC_13006a, MixValveOpening2, TT_13001, ZI_13001, FIC_13005, FIC_13004, FIC_13003, FIC_13002, FIC_13011, ]);





  return (
    <div className="Desalter2-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 273px",
          zIndex: 10,
        }}
      >
        ELECTRIC DESALINATION UNIT (B)
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      {/* XV-13001 */}
      <Valve
        className="XV-13001"
        tag="XV_13001"
        x={687}
        y={113}
        isClosed={valves.XV_13001}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13002 */}
      <Valve
        className="XV-13002"
        tag="XV_13002"
        x={985}
        y={385}
        isClosed={valves.XV_13002}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13003 */}
      <Valve
        className="XV-13003"
        tag="XV_13003"
        x={1087}
        y={83}
        isClosed={valves.XV_13003}
        toggle={toggleValve}
      />

      {/* XV-13004 */}
      <Valve
        className="XV-13004"
        tag="XV_13004"
        x={549}
        y={146}
        isClosed={valves.XV_13004}
        toggle={toggleValve}
      />




      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* PDV-13001 */}
        <div
            style={{ position: "absolute", left: 665, top: 525, transform: "rotate(90deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("PDV_13001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("PDV_13001")}
          >

            {hoveredValve === "PDV_13001" && (
              <div style={tagStyle}>
                PDV_13001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="PDV-13001">
                    
          <defs>
            <linearGradient id="metal_13001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* LCV-13001 */}
        <div
            style={{ position: "absolute", left: 1045, top: 571,}}
            onMouseEnter={() => setHoveredValve("LCV_13001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("LCV_13001")}
          >

            {hoveredValve === "LCV_13001" && (
              <div style={tagStyle}>
                LCV_13001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="LCV-13001">
                    
          <defs>
            <linearGradient id="metal_13001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-13001 */}
        <div
            style={{ position: "absolute", left: 445, top: 588,}}
            onMouseEnter={() => setHoveredValve("FCV_13001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_13001")}
          >

            {hoveredValve === "FCV_13001" && (
              <div style={tagStyle}>
                FCV_13001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13001">
                    
          <defs>
            <linearGradient id="metal_13001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         {/* FCV-13002 */}
        <div
            style={{ position: "absolute", left: 266, top: 756,}}
            onMouseEnter={() => setHoveredValve("FCV_13002")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_13002")}
          >

            {hoveredValve === "FCV_13002" && (
              <div style={tagStyle}>
                FCV_13002
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13002">
                    
          <defs>
            <linearGradient id="metal_13002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13002)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         {/* FCV-13003 */}
        <div
            style={{ position: "absolute", left: 297, top: 644,}}
            onMouseEnter={() => setHoveredValve("FCV_13003")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_13003")}
          >

            {hoveredValve === "FCV_13003" && (
              <div style={tagStyle}>
                FCV_13003
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13003">
                    
          <defs>
            <linearGradient id="metal_13003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13003)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         
         
         {/* FCV-13004 */}
        <div
            style={{ position: "absolute", left: 495, top: 528,}}
            onMouseEnter={() => setHoveredValve("FCV_13004")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_13004")}
          >

            {hoveredValve === "FCV_13004" && (
              <div style={tagStyle}>
                FCV_13004
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13004">
                    
          <defs>
            <linearGradient id="metal_13004">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13004)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13004)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         {/* FCV-13005 */}
        <div
            style={{ position: "absolute", left: 217, top: 424,}}
            onMouseEnter={() => setHoveredValve("FCV_13005")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_13005")}
          >

            {hoveredValve === "FCV_13005" && (
              <div style={tagStyle}>
                FCV_13005
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13005">
                    
          <defs>
            <linearGradient id="metal_13005">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13005)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13005)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

         {/* FCV-13006 */}
        <div
            style={{ position: "absolute", left: 787, top: 74,}}
            onMouseEnter={() => setHoveredValve("FCV_13006")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_13006")}
          >

            {hoveredValve === "FCV_13006" && (
              <div style={tagStyle}>
                FCV_13006
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13006">
                    
          <defs>
            <linearGradient id="metal_13006">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13006)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13006)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      



     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          
                    {/* ================= MDS FACEPLATE ================= */}
          
                    {showMDS && (
                      <Analyzer1Faceplate
                        close={() => setShowMDS(false)}
                        showBargeSelector={false}
                      />
                    )}


              {/* ================= CRUDE V-201A OUTLET FACEPLATE ================= */}
                    {showAnalyzerV201B && (
                      <AnalyzerV201BFaceplate
                        close={() =>
                          setShowAnalyzerV201B(false)
                        }
                      />
                    )
                  }
          



    {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.PDV_13001?.opening || 0)}
        x={648}
        y={545}
      />

      <ValveOutput
        value={Number(valveData?.LCV_13001?.opening || 0)}
        x={1067}
        y={616}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13001?.opening || 0)}
        x={467}
        y={633}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13002?.opening || 0)}
        x={287}
        y={803}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13003?.opening || 0)}
        x={317}
        y={690}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13004?.opening || 0)}
        x={517}
        y={570}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13005?.opening || 0)}
        x={238}
        y={470}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13006?.opening || 0)}
        x={808}
        y={118}
      />



      
        <button
          onClick={() => setShowMDS(true)}
          style={{
            position: "absolute",
            top: "735px",
            left: "550px",
            padding: "5px 2px",
            background: "#ff9800",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 500
          }}
        >
          Crude Analyzer
        </button>


        <button
          className="control-btn"

          style={{
            position: "absolute",
            left: "1010px",
            top: "160px",
            zIndex: 500
          }}

          onClick={() =>
            setShowAnalyzerV201B(true)
          }
        >
          V-201B Analyzer
        </button>




        <ElectricGridButton
          state={gridState}
          setState={setGridState}
          stopGrid={()=>setZI_13001(0)}
          x={787}
          y={203}
        />


        <ElectricGrid
          state={gridState}
          x={400}
          y={220}
          width={650}
          height={140}
          />






        <Transmitter
          tag="TT_13001"
          value={[TT_13001]}
          x={222}
          y={694}
          unit="°C"
          max={200}
          HH={186}
          H={165}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-104A/B TO INLET OF DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_13001"
          value={[FIC_13001]}
          x={135}
          y={694}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCTION CRUDE FROM PRE-HEAT TRAIN 1 HEAT EXCHANGER (E-101A/B TO E-104A/B) TO INLET OF DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_13002"
          value={[FIC_13002]}
          x={385}
          y={794}
          unit="mL/M"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF DECALCIFIER FROM DECALCIFIER UNIT TO DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_13003"
          value={[FIC_13003]}
          x={185}
          y={639}
          unit="mL/M"
          max={100}
          HH={80}
          H={70}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF DEMULSIFIER FROM DEMULSIFIER UNIT TO DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_13004"
          value={[FIC_13004]}
          x={185}
          y={584}
          unit="BPM"
          max={2.5}
          HH={2}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRIMARY WASH WATER FROM WATER SUPPLY PUMPS TO DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_13005"
          value={[FIC_13005]}
          x={185}
          y={524}
          unit="BPM"
          max={1.5}
          HH={1.1}
          H={0.6}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF RINSE WATER FROM WATER SUPPLY PUMPS TO  V-201A"
         />

         <Transmitter
          tag="FIC_13006"
          value={[FIC_13006]}
          x={138}
          y={422}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF OIL RETURN FROM V-201A TO V-201B OIL RETURN PUMPS"
         />

         <Transmitter
          tag="FIC_13007"
          value={[FIC_13007]}
          x={885}
          y={559}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF BRIME WATER DRAINAGE FROM V-201A TO E-201A/B"
         />

         <Transmitter
          tag="FIC_13008"
          value={[FIC_13008]}
          x={699}
          y={479}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF CRUDE, WASH WATER, DEMULSIFIER AND DECALCIFIER FROM PDV (DIFFERENTIAL PRESSURE MIXING VALVE) TO V-201A"
         />

         <Transmitter
          tag="FIC_13009"
          value={[FIC_13009]}
          x={885}
          y={114}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF DEHYDRATED CRUDE FROM V-201A TO V-201B"
         />


         <Transmitter
          tag="FIC_13010"
          value={[FIC_13010]}
          x={385}
          y={117}
          unit="BPM"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF RELIEVED MIXED SOLUTION OF PRESSURIZED DEHYDRATED CRUDE FROM V-201A TO OIL RETURN PUMPS TO SLOP TANK"
         />

         <Transmitter
          tag="FIC_13011"
          value={[FIC_13011]}
          x={1129}
          y={114}
          unit="BPM"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF DEHYDRATED CRUDE FROM V-201A AFTER SAMPLING POINT TO V-201B"
         />

        <Transmitter
          tag="FIC_13012"
          value={[FIC_13012]}
          x={1015}
          y={329}
          unit="BPM"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF UNQUALIED CRUDE FROM V-201B TO SLOP TANK"
         />

         <Transmitter
          tag="FIC_13013"
          value={[FIC_13013]}
          x={175}
          y={349}
          unit="BPM"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF DEHYDRATED CRUDE FROM V-201A OIL RETURN LINE TO V-201B OIL RETURN PUMPS"
         />

         <Transmitter
          tag="ZI_13001"
          value={[ZI_13001]}
          x={785}
          y={169}
          unit="kV"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="VOLTAGE OF ELECTRIC CURRENT AT THE ELECTRIC GRID OF V-201A"
         />



    <LevelTransmitterIndicator
      tag="LT-301"
      totalLevel={523}
      inflows={[FIC_13008]}
      outflows={[FIC_13009+FIC_13010 + FIC_13006c]}
      responseFactor={0.05}
      columnX={504}
      columnY={227}
      columnWidth={344}
      columnHeight={123}
      textX={360}
      textY={230}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.7}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT-302"
      totalLevel={523}
      inflows={[FIC_13013]}
      outflows={[FIC_13007]}
      responseFactor={0.05}
      columnX={504}
      columnY={227}
      columnWidth={344}
      columnHeight={123}
      textX={904}
      textY={240}
      showFlow={true}
      backgroundOpacity={0.00}
      liquidOpacity={0.3}
      service="water"
    />





            <Pump
              tag="P-250A"
              x={359}
              y={415}
              rpm={1800}
              bladeCount={pumpData?.["P-250A"]?.bladeCount || 3}
              size={pumpData?.["P-250A"]?.size || 38}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-250B"
              x={359}
              y={475}
              rpm={1800}
              bladeCount={pumpData?.["P-250B"]?.bladeCount || 3}
              size={pumpData?.["P-250B"]?.size || 38}
              onClick={openPumpPanel}
            />







    </div>
  );
}

export default Desalter2;